import * as tslib_1 from "tslib";
import { Topology } from '@wix/wixstores-client-core/dist/es/src/constants';
import { FilterEqOperation, MediaFrameMediaType, } from '../types/types';
import { query as getDataQueryString } from '../graphql/getData.graphql';
import { query as getCategoryProductsQueryString } from '../graphql/getCategoryProducts.graphql';
import { query as getFilteredProductsQueryString } from '../graphql/getFilteredProducts.graphql';
import _ from 'lodash';
import { SortDirection } from '@wix/wixstores-graphql-schema';
import { Experiments } from '../types/experiments';
var DataApi = /** @class */ (function () {
    function DataApi(siteStore) {
        this.siteStore = siteStore;
        //
    }
    DataApi.prototype.getInitialData = function (_a) {
        var externalId = _a.externalId, compId = _a.compId, limit = _a.limit;
        var data = {
            query: getDataQueryString,
            source: 'WixStoresWebClient',
            operationName: 'getData',
            variables: { externalId: externalId || '', compId: compId, limit: limit },
        };
        return this.sendRequest(data);
    };
    DataApi.prototype.getRelatedItems = function (_a) {
        var externalId = _a.externalId, compId = _a.compId, limit = _a.limit, productIds = _a.productIds;
        var data = {
            query: 'getRelatedItems',
            source: 'WixStoresWebClient',
            operationName: 'getRelatedItems',
            variables: { externalId: externalId, compId: compId, productIds: productIds, limit: limit },
        };
        return this.sendRequest(data);
    };
    DataApi.prototype.sendRequest = function (data) {
        return this.siteStore.httpClient.post(this.siteStore.resolveAbsoluteUrl("/" + Topology.STOREFRONT_GRAPHQL_URL), data);
    };
    DataApi.prototype.getCategoryProducts = function (variables) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                data = {
                    query: getCategoryProductsQueryString,
                    source: 'WixStoresWebClient',
                    operationName: 'getCategoryProducts',
                    variables: variables,
                };
                return [2 /*return*/, this.siteStore.httpClient.post(this.siteStore.resolveAbsoluteUrl("/" + Topology.STOREFRONT_GRAPHQL_URL), data)];
            });
        });
    };
    DataApi.prototype.getProducts = function (fromIndex, toIndex, filters, collectionIds, sorting) {
        if (filters === void 0) { filters = []; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var offset, limit, categoriesFilterIndex, categories, a;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.siteStore.experiments.enabled(Experiments.GalleryFilteredProductsGraphQL)) return [3 /*break*/, 2];
                        offset = fromIndex;
                        limit = toIndex - fromIndex;
                        categoriesFilterIndex = filters.findIndex(function (filter) { return filter.field === 'categories'; });
                        categories = _.uniq(_.compact([collectionIds.mainCategory].concat(collectionIds.subCategory, _.flatten(collectionIds.customCategories))));
                        if (categoriesFilterIndex > -1) {
                            filters[categoriesFilterIndex].values = categories;
                        }
                        else {
                            filters.push({
                                field: 'categories',
                                op: FilterEqOperation.IN_ALL,
                                values: categories,
                            });
                        }
                        return [4 /*yield*/, this.getProductsByGraphQL(offset, limit, filters, sorting)];
                    case 1:
                        a = _a.sent();
                        return [2 /*return*/, { list: _.compact(a.data.catalog.products.list), totalCount: 50 }];
                    case 2: return [4 /*yield*/, this.getProductsByViewAPI(fromIndex, toIndex, filters, collectionIds, sorting)];
                    case 3: return [2 /*return*/, (_a.sent()).productsWithMetaData];
                }
            });
        });
    };
    DataApi.prototype.getProductsByGraphQL = function (offset, limit, filters, sorting) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sort, variables, data;
            return tslib_1.__generator(this, function (_a) {
                sort = sorting
                    ? {
                        direction: sorting.direction === 'ASC' ? SortDirection.Ascending : SortDirection.Descending,
                        sortField: sorting.field,
                    }
                    : null;
                variables = {
                    offset: offset,
                    limit: limit,
                    sort: sort,
                    filters: {
                        and: filters.map(function (filter) {
                            if (filter.field.startsWith('options.')) {
                                var optionName_1 = filter.field.replace('options.', '');
                                var values = filter.values.map(function (value) { return optionName_1 + "#" + value; });
                                return {
                                    term: {
                                        field: 'optionChoices',
                                        op: 'IN',
                                        values: values,
                                    },
                                };
                            }
                            else {
                                return {
                                    term: filter,
                                };
                            }
                        }),
                    },
                };
                data = {
                    variables: variables,
                    query: getFilteredProductsQueryString,
                    source: 'WixStoresWebClient',
                    operationName: 'getFilteredProducts',
                };
                return [2 /*return*/, this.siteStore.httpClient.post(this.siteStore.resolveAbsoluteUrl("/" + Topology.STOREFRONT_GRAPHQL_URL), data)];
            });
        });
    };
    DataApi.prototype.getProductsByViewAPI = function (fromIndex, toIndex, filters, collectionIds, sorting) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var requestBody;
            return tslib_1.__generator(this, function (_a) {
                requestBody = {
                    viewName: 'StoreFrontFilteredCategoryProductsView',
                    params: {
                        limit: {
                            from: fromIndex,
                            to: toIndex,
                        },
                        filters: filters,
                        categories: collectionIds,
                    },
                };
                if (sorting) {
                    requestBody.params.sort = { field: sorting.field, direction: sorting.direction };
                }
                return [2 /*return*/, this.siteStore.httpClient
                        .post(this.siteStore.resolveAbsoluteUrl('/wix-ecommerce-storefront-web/catalog/view'), requestBody)
                        .then(function (res) {
                        var products = res.data.products.map(function (p) {
                            return tslib_1.__assign({}, p, { isInStock: p.inventoryStatus === 'in_stock', options: p.isOptionMandatory ? [{ id: 'dummy' }] : [], digitalProductFileItems: p.digitalProductFilesTypes.map(function (type) { return ({
                                    fileType: MediaFrameMediaType[type.toLowerCase()],
                                }); }) });
                        });
                        return {
                            id: '',
                            productsWithMetaData: { list: products, totalCount: res.data.totalCount },
                        };
                    })];
            });
        });
    };
    return DataApi;
}());
export { DataApi };
//# sourceMappingURL=DataApi.js.map